import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Slider from "react-slick";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import GalleryPageIamge from "../assets/img/GalleryPageIamge.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { motion } from "framer-motion";
import Fancybox2 from "../components/Fancybox2";
import barbieCakeZeppoli from "../assets/img/coverImageGallery/barbieCakeZeppoli.jpg";
import makeupCakeZeppoli from "../assets/img/coverImageGallery/makeupCakeZeppoli.jpg";
import babyShowerCakeZeppoli from "../assets/img/coverImageGallery/babyshowerCakeZeppoli.jpg";
import cartoonCakeZeppoli from "../assets/img/coverImageGallery/cartoonCakeZeppoli.jpg";
import lettersCakeZeppoli from "../assets/img/coverImageGallery/lettersCakeZeppoli.jpg";
import sportsCakeZeppoliOne from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliOne.png";
import sportsCakeZeppoliTwo from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliTwo.png";
import sportsCakeZeppoliThree from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliThree.png";
import sportsCakeZeppoliFour from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliFour.png";
import sportsCakeZeppoliFive from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliFive.png";
import sportsCakeZeppoliSix from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliSix.png";
import sportsCakeZeppoliSeven from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliSeven.png";
import sportsCakeZeppoliEight from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliEight.png";
import sportsCakeZeppoliNine from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliNine.png";
import sportsCakeZeppoliTen from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliTen.png";
import sportsCakeZeppoliEleven from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliEleven.png";
import sportsCakeZeppoliTwelve from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliTwelve.png";
import sportsCakeZeppoliThirteen from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliThirteen.png";
import sportsCakeZeppoliFourteen from "../assets/img/cakeImagesGallery/sports/sportsCakeZeppoliFourteen.png";

function SportsCakeGallery() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | Gallery | Sports Cake";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const directorsSliderSettings = {
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    cssEase: "linear",
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
  };

  // for gallery filters
  const allCards = [
    {
      category: "Cake",
      image: sportsCakeZeppoliOne,
      id: 1,
    },
    {
      category: "Cake",
      image: sportsCakeZeppoliTwo,
      id: 2,
    },
    {
      category: "Cake",
      image: sportsCakeZeppoliThree,
      id: 3,
    },
    {
      category: "Cake",
      image: sportsCakeZeppoliFour,
      id: 4,
    },
    {
      category: "Cake",
      image: sportsCakeZeppoliFive,
      id: 5,
    },
    {
      category: "Cake",
      image: sportsCakeZeppoliSix,
      id: 6,
    },
    {
      category: "Cake",
      image: sportsCakeZeppoliSeven,
      id: 7,
    },
    {
      category: "Pastry",
      image: sportsCakeZeppoliEight,
      id: 8,
    },
    {
      category: "Pastry",
      image: sportsCakeZeppoliNine,
      id: 9,
    },
    {
      category: "Pastry",
      image: sportsCakeZeppoliTen,
      id: 10,
    },
    {
      category: "Pastry",
      image: sportsCakeZeppoliEleven,
      id: 11,
    },
    {
      category: "Pastry",
      image: sportsCakeZeppoliTwelve,
      id: 12,
    },
    {
      category: "Pastry",
      image: sportsCakeZeppoliThirteen,
      id: 13,
    },
    {
      category: "Pastry",
      image: sportsCakeZeppoliFourteen,
      id: 14,
    },
  ];

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  // upside animation
  const variants5 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // for animation end

  return (
    <>
      <Navbar />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={variants5}
      >
        <div className="breadcumb-wrapper " data-bg-src={GalleryPageIamge}>
          <div
            className="container z-index-common"
            style={{ marginTop: "150px" }}
          >
            <div className="breadcumb-content">
              <h1 className="breadcumb-title text-white">Gallery</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                <li className="text-white">Gallery</li>
                <li className="text-white">Sports Cake</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>

      <section className="space">
        <div className="container">
          {isVisible && (
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={variants5}
            >
              <div className="title-area text-center">
                <span className="sub-title">Cake Gallery</span>
                <h2 className="sec-title">Our Latest Sports Cake</h2>
              </div>
            </motion.div>
          )}

          <div className="row gy-40 filter-active">
            {allCards.map((card) => (
              <div
                className={`col-xl-3 col-lg-4 col-sm-6 filter-item`}
                key={card.id}
              >
                {isVisible && (
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={variants5}
                  >
                    <div className="th-product product_style1">
                      <div
                        style={{
                          borderRadius: "12px",
                          height: "365px",
                        }}
                        className="mx-15"
                      >
                        <LazyLoadImage
                          alt="Zeppoli sports cake image"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={card.image}
                          placeholderSrc={card.image}
                          style={{
                            borderRadius: "12px",
                            width: "270px",
                          }}
                        />
                      </div>
                    </div>
                  </motion.div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {isVisible && (
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={variants5}
        >
          <div className="title-area text-center">
            <h2 className="sec-title">Explore More Categories</h2>
          </div>

          <div className="container">
            <div className="px-lg-4 px-3 my-5">
              <Fancybox2 options={opts}>
                <Slider
                  {...directorsSliderSettings}
                >
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery One Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={barbieCakeZeppoli}
                          placeholderSrc={barbieCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/barbiecakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Two Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={makeupCakeZeppoli}
                          placeholderSrc={makeupCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/makeupcakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Three Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={babyShowerCakeZeppoli}
                          placeholderSrc={babyShowerCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/babyshowercakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Four Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={cartoonCakeZeppoli}
                          placeholderSrc={cartoonCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/cartooncakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Five Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={lettersCakeZeppoli}
                          placeholderSrc={lettersCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/letterscakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </Slider>
              </Fancybox2>
            </div>
          </div>
        </motion.div>
      )}

      <Footer />
    </>
  );
}

export default SportsCakeGallery;
